/**
 * @module systemManager
 */
import { device as defaultDevice } from "../../../web/manager/system/device";
import { device as ps4Device } from "./device";
import { application } from "./application";
import { network } from "./network";

const device = Object.assign(defaultDevice, ps4Device);

export const system = {
  device,
  application,
  network
};
